<script>
    // CommitChart.js
    import {Pie} from 'vue-chartjs'
    import Utils from "../../scripts/utils";

    export default {
        extends: Pie,
        data() {
            return {
                lastData: this.data,
                //colors:['#394956', '#3d576a', '#3f667f', '#3f7595', '#3c85aa', '#3595c0', '#28a5d7', '#00b6ed']
                colors: ['#142850', '#27496d', '#00909e', '#00b6ed', '#126e82', '#51c4d3', '#a7bbc7', '#dae1e7',]
            }
        },
        props: {
            labels: {
                required: true,
                type: Array
            },
            data: {
                required: true,
                type: Array
            },
            unit: {
                type: String,
                default: ''
            },
            digits: {
                type: Number,
                default: 0
            },
            title: {
                type: String,
                default: ''
            },
            width: {
                type: Number,
                default: 500
            },
            height: {
                type: Number,
                default: 500
            }
        },
        computed: {
            chartData: function () {
                return this.data;
            },
            length() {
                return Utils.calcColWidth * 0.7;
            },
            editedData() {
                if (this.data.length <= 8) {
                    return {
                        data: this.data,
                        labels: this.labels
                    }
                }
                let labels = []
                for (let i = 0; i < this.data.length; i++) {
                    labels[this.data[i]] = this.labels[i];
                }
                let copy = this.data;
                let tmp = copy.sort((a, b) => b - a);
                let tmp2 = {data: [], labels: []};
                let others = 0;
                for (let i = 0; i < tmp.length; i++) {
                    if (i < 7) {
                        tmp2.data.push(tmp[i]);
                        tmp2.labels.push(labels[tmp[i]]);
                    } else {
                        others += tmp[i]
                    }
                }
                if (others > 0) {
                    tmp2.data.push(others)
                    tmp2.labels.push('Sonstige')
                }
                return tmp2;
            }
        },
        mounted() {
            this.renderPieChart(true);
            window.addEventListener('resize', function () {
                this.reRender(false)
            }.bind(this));
        },
        methods: {
            renderPieChart(animated) {
                this.$refs.canvas.style['max-width'] = this.width + 'px';
                this.$refs.canvas.style['max-height'] = this.width + 'px';
                const options = {
                    //  responsive: false,
                    // maintainAspectRatio: false,
                    animation: {
                        duration: animated ? 1000 : 0
                    },
                    tooltips: {
                        callbacks: {
                            label: function(tooltipItem,data) {
                                let number = data['datasets'][0]['data'][tooltipItem['index']];
                                let label = data['labels'][tooltipItem['index']];
                                number = parseFloat(number);
                                number =  number.toLocaleString('de-DE', {
                                    minimumFractionDigits: this.digits,
                                    maximumFractionDigits: this.digits
                                });
                                return label+':  '+number + ' ' +this.unit;
                            }.bind(this)
                        }
                    },
                    legend: {
                        display: false
                    },
                    title: {
                        display: this.title !== '',
                        text: this.title
                    }
                };
                // Overwriting base render method with actual data.
                this.renderChart({
                    labels: this.editedData.labels,
                    datasets: [
                        {
                            backgroundColor: this.colors,
                            data: this.editedData.data
                        }
                    ]
                }, options)
            },
            arrayDiff(a, b) {
                return [...b.reduce((acc, v) => acc.set(v, (acc.get(v) || 0) - 1),
                    a.reduce((acc, v) => acc.set(v, (acc.get(v) || 0) + 1), new Map())
                )].reduce((acc, [v, count]) => acc.concat(Array(Math.abs(count)).fill(v)), []);
            }
            ,
            reRender(animated) {
                this._data._chart.destroy();
                this.renderPieChart(animated);
            }

        },
        watch: {
            data: function () {
                if (this.arrayDiff(this.data, this.lastData).length > 0) {
                    this.lastData = this.data;
                    this.reRender(true);
                }
            },
            editedData() {
                this.reRender(true);
            }
        }
    }
</script>

<style scoped>

    canvas {
        background-color: white;
        padding: 12px;
        margin: auto;
    }

    /*  @media (max-width: 767px) {
          canvas {
             // min-width: 90%;
          }
      }*/

</style>